import LogoOrganogenesis from '../../../../public/images/logo-organogenesis.svg';
import {
  FooterCopyright,
  ReferToApligraphBlock,
  ScrollToTopButton,
} from './libs/components/components';
import Link from 'next/link';

const footerLinks = [
  {
    label: 'CONTACT ORGANOGENESIS',
    link: 'https://organogenesis.com/contact-us/',
  },
  {
    label: 'TERMS OF USE',
    link: 'https://organogenesis.com/terms-of-use.html',
  },
  {
    label: 'PRIVACY POLICY',
    link: 'https://organogenesis.com/privacy.html',
  },
  {
    label: 'COOKIE POLICY',
    link: 'https://organogenesis.com/cookie-policy.html',
  },
];

const Footer = () => {
  return (
    <footer
      className="relative bg-wcw-footer-bg pt-[60px] pb-[30px] text-wcw-footer-text w-full px-5"
      role="contentinfo"
      aria-labelledby="site-footer-heading"
    >
      <h2 id="site-footer-heading" className="sr-only">
        Site footer
      </h2>
      <div className="flex flex-col lg:flex-row justify-center gap-y-16 gap-x-[60px] mx-auto">
        <Link
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Organogenesis home (opens in a new tab)"
          href="https://www.organogenesis.com"
        >
          <LogoOrganogenesis
            className="w-[290px] h-[29px] mt-1"
            aria-hidden="true"
          />
        </Link>
        <div className="flex flex-col gap-y-6">
          <nav aria-label="Footer links">
            <p className="flex flex-wrap font-bold text-lg">
              {footerLinks.map(({ label, link }, index) => (
                <span key={label}>
                  <Link
                    className="fancy-underline leading-4 lg:leading-normal"
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${label} (opens in a new tab)`}
                  >
                    <span className="fancy-underline-text">{label}</span>
                  </Link>
                  {index < footerLinks.length - 1 && (
                    <>
                      <span className="mx-2 font-bold">|</span>
                    </>
                  )}
                </span>
              ))}
            </p>
          </nav>
          <ReferToApligraphBlock />
          <div>
            <FooterCopyright />
            <p>All rights reserved.</p>
          </div>
          <div>
            <p>
              Affinity, Novachor, and PuraPly are registered trademarks of
              Organogenesis Inc.
            </p>
            <p>
              Apligraf is a registered trademark of Novartis; Cygnus Dual is a
              registered trademark of Vivex Biologics, Inc.
            </p>
          </div>
        </div>
      </div>
      <ScrollToTopButton className="absolute -top-[23px] lg:-top-[31px] right-[10%]" />
    </footer>
  );
};

export { Footer };
